import React from "react";
import './App.css';
import theme from './components/theme';
import {ThemeProvider} from '@material-ui/core';
import GlobalStyles from './components/GlobalStyles';
import Routing from "./components/Routing";
import {Provider} from "react-redux";
import store from "./redux/store";

function App() {

    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <GlobalStyles/>
                <Routing/>
            </ThemeProvider>
        </Provider>
    );
}

export default App;
